module.exports = __webpack_public_path__ + "static/img/首页loading黑金.0096927a.png";